import useSWR from "swr";


type Ratings = {
  id: string;
  restaurant_name: string;
  overall: number;
  food: number;
  drink: number;
  customer_service: number;
  hygiene: number;
  comment: string;
  posted_at: string;
}[]
type PaginatedRatings = {
  count: number;
  ratings: Ratings;
};
export const useFetchPaginatedRatingsByKuitanAgentId = (pageSize: number, currentPage: number, kuitanAgentId?: string,) => {
  const fetcherKey = kuitanAgentId ? `kuitan/kuitan-agents/${kuitanAgentId}/ratings/paginated/?pageSize=${pageSize}&currentPage=${currentPage}` : null
  const { data: paginatedRatings, error, isLoading } = useSWR<PaginatedRatings>(fetcherKey)
  return { paginatedRatings, isLoading, error };
};